import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import { renderRedirect } from "../util"
import { generateDocument } from "./Pay/api"
import { setDigioOption } from "../util/digio"
import { fetchSignApplication } from "./BasicProfile/api";
import { spinnerService } from "../Components/spinner.service";

import Footer from "../Components/footer";
const configApp = require('../config');


class ReviewDocument extends Component {

  state = {
    loading: false,
    pdfGenerated: false,
    error: "",
    isJointAccount: false,
    fullName: "",
    jointHolder2: "",
    jointHolder3: "",
    hasClickedReview: false,
    hasSignedReturn: false
  };

  async componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasSignedReturn = urlParams.has("digio_code") || urlParams.get("status") === "success";
    if (hasSignedReturn) {
      this.setState({ hasClickedReview: true, hasSignedReturn: true });
    }
    if (urlParams.has("status") || urlParams.has("error_code") || urlParams.has("digio_code")) {
      const statusVal = urlParams.get("status");
      if (statusVal === "success" || urlParams.has("digio_code")) {
        this.setState({ loading: true });
        spinnerService.show("mainSpinner", "Verifying signatures...");
        try {
          await this.handleRedirect();
          return;
        } catch (err) {
          console.error("Auto redirect error:", err);
          this.setState({ error: "Signature completed but status sync failed. Please click 'RETRY STATUS UPDATE' to proceed." });
          spinnerService.hide("mainSpinner");
        }
      }
      let options = setDigioOption(configApp.REACT_APP_DIGIO_ENV, "https://uat.trdr.money/images/trdr-horizontal.png", "#000000", "#FFFFFF", this.handleRedirect);
      let digio = new window.Digio(options);
      digio.init();
    }
    try {
      const res = await fetchSignApplication();
      if (res?.data?.fetch_signup_application) {
        const app = res.data.fetch_signup_application;
        this.setState({
          isJointAccount: app.is_joint_account,
          fullName: app.fullName,
          jointHolder2: app.joint_holder_second_fullname,
          jointHolder3: app.joint_holder_third_fullname,
        });
      }
    } catch (e) {
      console.error("Error fetching signup application:", e);
    }
  }

  handleRedirect = async () => {
    await renderRedirect(this.props, "/complete");
  }

  callDigio = async () => {
    this.setState({ hasClickedReview: true });
    await this.doGenerate(true);
  }

  callSubmit = async () => {
    await this.doGenerate(false);
  }

  doGenerate = async (isPreview) => {
    this.setState({ loading: true, error: "" });
    spinnerService.show("mainSpinner", "Generating agreement document...");

    try {
      let doc = await generateDocument(isPreview);
      let docid;

      if (doc.errors) {
        let errMsg = "Facing server delays, please try again in a few minutes.";
        if (Array.isArray(doc.errors) && doc.errors.length > 0) {
          const firstError = doc.errors[0]?.message || "";
          if (firstError.toLowerCase().includes("estamp") || firstError.toLowerCase().includes("stamp")) {
            errMsg = "Insufficient Estamp credentials. Please Contact Us.";
          } else if (firstError) {
            errMsg = firstError;
          }
        }
        this.setState({ error: errMsg, hasClickedReview: false });
        spinnerService.hide("mainSpinner");
        return false;
      }

      if (doc && doc.data) {
        docid = doc.data.generate_agreement_document?.id;
      }
      let documentData = doc.data.generate_agreement_document;

      // Sandbox preview mode: download PDF as attachment, show Submit button
      if (isPreview && documentData && documentData.preview_url) {
        console.log("[SANDBOX] Downloading preview PDF:", documentData.preview_url);
        const a = document.createElement("a");
        a.href = documentData.preview_url;
        a.download = documentData.file_name || "Agreement_Preview.pdf";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.setState({ pdfGenerated: true });
        spinnerService.hide("mainSpinner");
        return;
      }

      // Use redirect approach for joint accounts to bypass iframe restrictions
      let isIframe = !this.state.isJointAccount;
      let options = setDigioOption(configApp.REACT_APP_DIGIO_ENV, "https://uat.trdr.money/images/trdr-horizontal.png", "#000000", "#FFFFFF", this.handleRedirect, isIframe);
      let digio = new window.Digio(options);
      digio.init();
      
      spinnerService.show("mainSpinner", "Opening signing gateway...");
      digio.submit(
        documentData.id,
        documentData.customer_identifier,
        documentData.access_token.id
      );
    } catch (e) {
      console.log("digio document submit", e);
      this.setState({ error: "Facing server delays, please try again in a few minutes.", hasClickedReview: false });
      spinnerService.hide("mainSpinner");
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    return (<div className="col-md-6 col-lg-5 col-xl-4">

      <div className="container my-auto py-4 bg-white shadow-lg rounded">
        <div className="row mt-2">
          <div className="col-11 col-lg-11 mx-auto">
            <h1>Review Document</h1>

            <div className="contentArea">

              <p>We are preparing your account opening document for you to sign.</p>
              
              {this.state.isJointAccount ? (
                <div className="alert alert-info border-0 p-3 mb-3" style={{ fontSize: "13px", backgroundColor: "#f0f8ff", borderRadius: "8px", color: "#333" }}>
                  <h6 style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "8px", color: "#004085" }}>Joint Account E-Sign Flow:</h6>
                  <ul className="pl-3 mb-0" style={{ listStyleType: "decimal" }}>
                    <li className="mb-1"><strong>Primary Holder ({this.state.fullName || "You"}):</strong> Enter Aadhaar number and OTP inside the review window to sign.</li>
                    {this.state.jointHolder2 && <li className="mb-1"><strong>Second Holder ({this.state.jointHolder2}):</strong> Will receive an SMS & Email notification with a link to sign.</li>}
                    {this.state.jointHolder3 && <li className="mb-0"><strong>Third Holder ({this.state.jointHolder3}):</strong> Will receive an SMS & Email notification with a link to sign.</li>}
                  </ul>
                </div>
              ) : (
                <p className="text-2">After review, eSign your form using your Aadhaar Number.</p>
              )}

              <p className="text-2">
                <ul>
                  <li>Click Review to view your account opening form to Sign it.</li>
                  <li>Enter your Aadhaar number</li>
                  <li>Enter OTP received on mobile number linked with Aadhaar</li>
                </ul>
              </p>
            </div>

            <form id="registerForm" className="form-border" method="post">



              <button
                className="btn btn-primary btn-block text-uppercase mt-4"
                type="button"
                onClick={this.callDigio}
                disabled={this.state.loading || this.state.hasClickedReview}
              >
                {this.state.loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>{" "}
                    Processing...
                  </>
                ) : (
                  "REVIEW"
                )}
              </button>

              {this.state.hasSignedReturn && (
                <button
                  className="btn btn-warning btn-block text-uppercase mt-2"
                  type="button"
                  onClick={this.handleRedirect}
                  disabled={this.state.loading}
                >
                  RETRY STATUS UPDATE
                </button>
              )}

              {this.state.pdfGenerated && (
                <button
                  className="btn btn-success btn-block text-uppercase mt-2"
                  type="button"
                  onClick={this.callSubmit}
                >
                  SUBMIT &amp; CONTINUE
                </button>
              )}
            </form>

            {this.state.error && (
              <div className="alert alert-danger mt-3 text-center" role="alert" style={{ fontSize: "14px" }}>
                {this.state.error.includes("Contact Us") ? (
                  <>
                    Insufficient Estamp creds, please report to us at ->{" "}
                    <a href="https://trdr.money/#footer" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline", color: "inherit", fontWeight: "bold" }}>
                      Contact Us
                    </a>
                  </>
                ) : (
                  <div>
                    <p className="mb-2">{this.state.error}</p>
                    {this.state.error.toLowerCase().includes("signature") && (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger font-weight-bold mt-1"
                        onClick={() => renderRedirect(this.props, "/signature")}
                      >
                        Go to Signature Upload
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      </div><Footer />
    </div>

    )
  }
}
export default withRouter(ReviewDocument);
